import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../../../api/config';

// const url = `${PREFIX_URL}/v01/inbox/getByDocId`;
const url = `${PREFIX_URL}/inbox-threads/:inboxEntryId/emails/:emailId/attachments/:fileId`;

type GetFileDetailsResponse = {
  data: any;
  status: boolean;
};

export const getFileDetails = ({
  projectId,
  inboxEntryId,
  emailId,
  fileId,
}): Promise<GetFileDetailsResponse> => {
  return axios.get(
    generateRoutePath(url, {
      projectId: projectId,
      inboxEntryId: inboxEntryId,
      emailId: emailId,
      fileId: fileId,
    })
  );
};

export const emailFileDetailsKeys = {
  all: ['fileDetails'] as const,
  detail: ({
    projectId,
    fileId,
    emailId,
    inboxEntryId,
  }: {
    projectId: string;
    fileId: number;
    emailId: number;
    inboxEntryId: number;
  }) =>
    [
      INBOX_API_KEY,
      ...emailFileDetailsKeys.all,
      projectId,
      fileId,
      { emailId, inboxEntryId },
    ] as const,
};

type QueryFnType = typeof getFileDetails;

type useEmailFileDetailsOptions = {
  projectId: string;
  fileId: number;
  inboxEntryId: number;
  emailId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useEmailFileDetails = ({
  projectId,
  fileId,
  config,
  ...otherParams
}: useEmailFileDetailsOptions) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...emailFileDetailsKeys.all, projectId, fileId, otherParams],
    queryFn: () => getFileDetails({ projectId, fileId, ...otherParams }),
    staleTime: Infinity,
    ...config,
  });
};
